import script from "./ThirdStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ThirdStep.vue?vue&type=script&setup=true&lang=js"

import "./ThirdStep.vue?vue&type=style&index=0&id=3a64884e&scoped=true&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\bestphone\\main_apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a64884e"]])

export default __exports__